import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExportMenu from "../../../Common/ExportMenu/ExportMenu";

export const ExportDesignation = ({ designationData }) => {
    const exportToExcel = async () => {

        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Designation");

        // Define styles
        const boldFont = { bold: true };

        // Get current date and time
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Designation Details Generated on: ${formattedDate}, ${formattedTime}`;

        // Add the downloadDateTime to the worksheet
        worksheet.addRow(["", "", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 4);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        // Add "Designation Details" header
        worksheet.addRow(["", "", "Designation Details", ""]);
        worksheet.mergeCells(2, 2, 2, 4);
        worksheet.getCell(2, 2).value = "Designation Details";
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        // Define table headers
const tableHeaderRow = worksheet.addRow(["S.No", "Department", "Designation", "Status"]);
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.alignment = { horizontal: "left" };
            if (colNumber >= 1 && colNumber <= 4) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "003366" },
                    bgColor: { argb: "FFFFFFFF" }
                };
            }
        });

        // Add data rows
        designationData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.departmentName || "N/A",
                item.designationName || "N/A",
                item.isActive ? "Active" : "InActive",
            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.alignment = { horizontal: "center" };
            });
        });

        // Set column widths dynamically based on content
        worksheet.columns = [
            { width: 5 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
        ];

        // Save the workbook to a file
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Designation.xlsx";
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };
    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Designation Report Generated on: ${formattedDate} ${formattedTime}`;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Designation Details", 14, 20);
        doc.setFontSize(12);
        doc.text(downloadDateTime, 14, 30);

        const tableColumn = ["S.No", "Department", "Designation", "Status"];
        const tableRows = designationData.map((row, index) => [
            index + 1,
            row.departmentName || "N/A",
            row.designationName || "N/A",
            row.isActive ? "Active" : "InActive"
        ]);

        const tableOptions = {
            startY: 40,
            head: [tableColumn],
            body: tableRows,
            theme: "grid",
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: "linebreak",
                valign: "middle",
            },
            headStyles: {
                fillColor: [0, 51, 102],
                textColor: [255, 255, 255],
                fontStyle: "bold",
            },
            bodyStyles: {
                fontSize: 8,
                halign: "left",
            },
        };
        autoTable(doc, tableOptions);
        doc.save("Designation.pdf");
    };
    return (
        <ExportMenu
            items={[
                { label: "Excel", icon: "fa-solid fa-file-excel", onClick: exportToExcel },
                { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: exportToPDF },
            ]}
        />
    )
}